import { FC, useState } from 'react';
import { useClientState } from 'dibs-react-hooks/exports/useClientState';

// components
import { Link } from 'dibs-elements/exports/Link';
import { FormattedMessage } from 'dibs-react-intl';
import { BidHistoryModalLazy } from 'dibs-auctions/exports/BidHistoryModalLazy';

// styles
import styles from './PdpSharedAuctionViewHistory.scss';

type Props = {
    currency: string;
    itemId: string | null;
};

type RelayVariables = {
    isClient: boolean;
};

type ReduxStoreType = {
    relayVariables: {
        variables: RelayVariables;
    };
};

export const PdpSharedAuctionViewHistory: FC<Props> = ({ currency, itemId }) => {
    const [isBidModalOpen, setIsBidModalOpen] = useState<boolean>(false);
    const isClient = useClientState();

    if (!itemId || !isClient) {
        return null;
    }

    return (
        <div className={styles.container}>
            <Link onClick={() => setIsBidModalOpen(true)}>
                <FormattedMessage
                    id="PdpSharedAuctionClosed.viewBiddingHistory"
                    defaultMessage="View Bidding History"
                />
            </Link>
            <BidHistoryModalLazy
                page="pdp"
                itemId={itemId}
                isClient={isClient}
                currency={currency}
                isOpen={isBidModalOpen}
                onClose={() => setIsBidModalOpen(false)}
            />
        </div>
    );
};
